<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="fixed z-20 w-48 hidden sm:block bottom-14 right-4">
    <div class="bg-slate-800 border-1 border-slate-700">
      <div class="content-header">{{ t('map.settleLegend.title') }}</div>
      <div class="text-xs text-subtext p-2">{{ t('map.settleLegend.description') }}</div>
      <div class="p-2 text-green-500">{{ t('map.settleLegend.excellent') }}</div>
      <div class="pl-2 pb-2 text-cyan-500">{{ t('map.settleLegend.good') }}</div>
      <div class="pl-2 pb-2 text-subtext">{{ t('map.settleLegend.normal') }}</div>
      <div class="pl-2 pb-2 text-amber-400">{{ t('map.settleLegend.poor') }}</div>
      <div class="pl-2 pb-2 text-red-500">{{ t('map.settleLegend.bad') }}</div>
      <div class="text-xs text-subtext p-2" v-html="t('map.settleLegend.settlerInbound', { white: '<span class=\'text-white\'>' + t('map.settleLegend.white') + '</span>' })"></div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>